// --- BASE ---
import React from 'react';

// --- BASE DEV ---
import { faker } from '@faker-js/faker';

// --- INTERFACES ---
import { IRequest } from '../../Interfaces';

interface IProps {
	asset: IRequest;
	setAsset: (value: IRequest) => void;
}

const FillValues = (props: IProps) => {
	const { asset, setAsset }: IProps = { ...props };

	function fillValues() {
		const newAsset: IRequest = asset !== null ? { ...asset } : {};

		newAsset.address1 = faker.location.streetAddress();
		newAsset.address2 = faker.location.secondaryAddress();
		newAsset.city = faker.location.city();
		newAsset.company_name = faker.company.name();
		newAsset.country_code = 'US';
		newAsset.email = faker.internet.email();
		newAsset.email_confirmation = newAsset.email;
		newAsset.first_name = faker.person.firstName();
		newAsset.last_name = faker.person.lastName();
		newAsset.notes = faker.lorem.paragraph();
		newAsset.password = faker.internet.password();
		newAsset.password_confirmation = newAsset.password;
		newAsset.phone = faker.phone.number();
		newAsset.postal_code = faker.location.zipCode();
		newAsset.state = faker.location.state({ abbreviated: true });

		setAsset(newAsset);
	}

	return (
		<button
			className="btn btn-warning"
			onClick={() => fillValues()}
			type="button">
			Fill Values
		</button>
	);
};

export default FillValues;
